module.exports = __webpack_public_path__ + "media/src/images/course-placeholder-26fdf02614bc929dea5422ddf71bf365.jpg";